<template>
  <div class="checkbox-container">


    <div class="tab-subheading">{{label}}</div>
    <div class="checkbox-category">
      <div class="equipment-item check-ctn"  v-for="attribut in options" :key="attribut.id">
        <label> {{attribut.name}}<input type="checkbox" :data-label="attribut.name" :class="category"   :id="category + '-' + attribut.id" :name="name" :value="attribut.id" :checked="attribut.selected || selectedItem" ><span class="checkmark"></span></label>
      </div>
    </div>
  </div>

</template>

<script>
export default {
name: "Checkbox",
  props: {
    category: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    preselect: {
      type: Array
    },
    name: {
      type: String
    },
    options: {
      type: Array
    },
    selectedItem: {
      type: Boolean
    }
  },
  data() {
    return {
      attributes: this.$parent.attrs,

    }
  }
}
</script>

<style  lang="scss">

.checkbox-category{
  grid-template-columns: repeat(3, 1fr);
  display: grid;
  grid-gap: 12px;
}
</style>